import { Switch } from "../../components/ui/switch";

export const VisibilitySwitch = ({ product, onToggle }) => {
  if (product.archived) {
    return <span className="text-xs font-medium text-[#5E4D5A]" data-testid={`status-${product.id}`}>Archived</span>;
  }
  const visible = !product.hidden;
  return (
    <label className="inline-flex items-center gap-2 cursor-pointer">
      <Switch
        checked={visible}
        onCheckedChange={() => onToggle(product)}
        aria-label={`${product.name} visible on store`}
        data-testid={`toggle-${product.id}`}
        className="data-[state=checked]:bg-[#5E6B51] data-[state=unchecked]:bg-[#D8CDBC]"
      />
      <span
        className={`text-xs font-semibold px-2 py-0.5 rounded-full ${visible ? "bg-[#E4E9DC] text-[#3E4A34]" : "bg-[#EAE0D2] text-[#5A433B]"}`}
        data-testid={`status-${product.id}`}
      >
        {visible ? "Visible" : "Hidden"}
      </span>
    </label>
  );
};
